/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Login_TitleInputs */

const cs_portal_login_title = /** @type {(inputs: Portal_Login_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení do klientského portálu`)
};

const en_portal_login_title = /** @type {(inputs: Portal_Login_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client portal login`)
};

/**
* | output |
* | --- |
* | "Client portal login" |
*
* @param {Portal_Login_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_login_title = /** @type {((inputs?: Portal_Login_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Login_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_login_title(inputs)
	return cs_portal_login_title(inputs)
});